




































export default {
  name: 'Devices',
};
